import React, { useState } from "react";
import { SettingsContainer } from "../../../components/molecules/settingsContainer";
import { Flex } from "rebass/styled-components";
import AvatarUpload from "../../../pages/profileSettings/accountSections/avatar/avatarUpload";
import Modal from "../../../components/wrappers/modal";
import { Button } from "../../../components/atoms/form/button";
import { Avatar } from "../../../components/atoms/avatar";
import { DividerAlt } from "../../../components/atoms/dividerAlt";
import { useTranslation } from "react-i18next";

const ChangeAvatar = ({ allstarUser, getFreshProfile }) => {
  const { t } = useTranslation(`translation`, {
    keyPrefix: "profile.account",
  });
  const [isAvatarModalOpen, setAvatarModalOpen] = useState(false);
  // console.log(allstarUser);
  return (
    <SettingsContainer title={t("changePicture")} mb={5}>
      <DividerAlt></DividerAlt>

      <Flex mt={5} justifyContent="flex-start" flexDirection="column">
        <Avatar mb={5} size="large" image={allstarUser.myAvatar}></Avatar>
        <Flex justifyContent="flex-start">
          <Button
            size="small"
            flex={true}
            mt={2}
            onClick={() => {
              setAvatarModalOpen(true);
            }}
            name="avatar-upload-button"
          >
            {t("uploadPicture")}
          </Button>
        </Flex>
      </Flex>
      <Modal isModalOpen={isAvatarModalOpen} setModalOpen={setAvatarModalOpen}>
        <AvatarUpload
          setModalOpen={setAvatarModalOpen}
          allstarUser={allstarUser}
          getFreshProfile={getFreshProfile}
        />
      </Modal>
    </SettingsContainer>
  );
};

export { ChangeAvatar };
